module.exports = __webpack_public_path__ + "img/ro1.2f4546cb.jpg";